export default __webpack_public_path__ + "static/media/qr.0509eb92.svg";